import multiguard from 'vue-router-multiguard'

import RegisterPage from '../../views/auth/RegisterPage.vue'
import LoginPage from '../../views/auth/LoginPage.vue'
import ResetPasswordRequestPage from '../../views/auth/ResetPasswordRequestPage.vue'
import ResetPasswordPage from '../../views/auth/ResetPasswordPage.vue'

import { guest } from "../middlewares";


export default [
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    beforeEnter: multiguard([guest])
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    beforeEnter: multiguard([guest])
  },
  {
    path: '/reset-password/request',
    name: 'reset_password.request',
    component: ResetPasswordRequestPage,
    beforeEnter: multiguard([guest])
  },
  {
    path: '/reset-password',
    name: 'reset_password',
    component: ResetPasswordPage,
    beforeEnter: multiguard([guest])
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/auth.js